import { render } from "./PageProntuarioCSIPM.vue?vue&type=template&id=257a9821"
import script from "./PageProntuarioCSIPM.vue?vue&type=script&lang=js"
export * from "./PageProntuarioCSIPM.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./PageProntuarioCSIPM.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__